<template>
  <div class="card height-auto v-application--is-ltr text-left">
    <div class="card-body">
      <v-row class="headerTable-div">
        <v-col md="4" sm="12" style="text-align: left">
          <p class="title main-color">Percentage Segments</p>
          <p v-if="year_name">{{ year_name }}</p>
        </v-col>
        <v-col md="5" sm="12"> </v-col>
        <v-col md="3" sm="12">
          <v-btn
            class="modal-btn-save- main-color text-capitalize"
            style="border: 1px solid"
            @click="show_dialog = true"
            large
            >{{ $t("Generate Report") }}</v-btn
          >
        </v-col>
        <v-divider
          style="background-color: #ddd !important; margin-bottom: 20px"
          class="mt-4 mb-4 main-color"
        ></v-divider>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-form v-model="valid" ref="form" class="mt-5">
            <div class="semesters">
              <div class="actions">
                <v-icon
                  v-if="!editMode"
                  :title="$t('Edit')"
                  style="cursor: pointer"
                  class="main-color edit-icon"
                  @click="editMode = true"
                  >edit</v-icon
                >
                <!-- <span
                  v-if="edit_mode"
                  class="main-color pr-3"
                  style="cursor: pointer"
                  @click="saveMarks"
                  >{{ $t("Update") }}</span
                >
                <span
                  v-if="edit_mode"
                  style="color: #646464; cursor: pointer"
                  @click="
                    edit_mode = false;
                    getClassStudents();
                  "
                  >{{ $t("Cancel") }}</span
                > -->
              </div>
              <ul class="list-unsyled">
                <li
                  v-for="(item, index) in items"
                  :key="index"
                  style="margin-bottom: 2rem; overflow: hidden"
                >
                  <div class="semester-name">
                    <span class="name">{{ item.semester_name }} : </span>
                    <span class="percentage"
                      >{{ item.semester_percentage }}
                    </span>
                    <span class="equal main-color">=</span>
                    <p
                      class="red--text dur-error"
                      style="font-size: 10px; font-weight: 500"
                      v-if="item.show_error"
                    >
                      Sum of Quarters must be equal to the Total thier Semester
                    </p>
                  </div>

                  <div class="quarter-name">
                    <div
                      v-for="(q, index2) in item.quarters"
                      :key="index2"
                      class="quarter"
                    >
                      <span class="name">{{ q.quarter_name }} : </span>
                      <span v-if="!editMode" class="percentage"
                        >{{ q.quarter_percentage }}
                      </span>
                      <v-text-field
                        :rules="[
                          validationRules.required,
                          validationRules.numeric,
                        ]"
                        v-model="q.quarter_percentage"
                        @keyup="calculate(item)"
                        class="input-percentage"
                        solo
                        style="
                          max-width: 100px !important;
                          display: inline-block;
                        "
                        dense
                        v-if="editMode"
                        @focus="onFocus()"
                      ></v-text-field>

                      <span
                        v-if="
                          item.quarters.length > 1 &&
                          index2 < item.quarters.length - 1
                        "
                        class="equal-s main-color"
                        >+</span
                      >
                    </div>
                  </div>
                </li>
                <v-divider class="mt-4 mb-4 main-color divider"></v-divider>
                <div class="semester-name">
                  <span class="name">Total : </span>
                  <span class="percentage">{{ total_percentage }} </span>
                  <p
                    class="red--text dur-error"
                    v-if="show_error_for_total"
                    style="font-size: 10px; font-weight: 500"
                  >
                    Must equal 100
                  </p>
                </div>
                <div class="action">
                  <v-btn
                    class="modal-btn-save saveBtn"
                    @click="save"
                    v-if="editMode"
                    :loading="loading"
                    :disabled="show_error_for_tota && loading"
                    >{{ $t("Save") }}</v-btn
                  >
                </div>
              </ul>
            </div>
          </v-form>
        </v-col>
        <!-- <v-col md="4"></v-col> -->
      </v-row>
    </div>

    <v-dialog
      v-model="show_dialog"
      persistent
      max-width="500"
      class="dialog_confirm"
    >
      <v-card>
        <v-card-title class="headline">{{ $t("Select Grade") }}</v-card-title>

        <v-card-text>
          <v-row style="margin-bottom:-8px !important">
            <v-col cols="12" md="3"
              ><label style="margin-top: 28% !important; display: inline-block"
                ><strong>{{ $t("Grade") }}</strong>
              </label></v-col
            >
            <v-col cols="12" md="9">
              <div class="form-group">
                <v-autocomplete
                  v-model="academic_grade_id"
                  solo
                  :items="grades"
                  @change="hideLabel = true"
                  item-text="name"
                  item-value="academic_grade_id"
                >
                </v-autocomplete>
              </div>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="12" v-if="show_export_error">
              <p class="error-txt red--text" style="text-align: center">
                {{ export_error_msg }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-5 pb-5">
          <v-spacer></v-spacer>

          <v-btn
            right
            class="modal-btn-cancel noBtn mr-2"
            id="noBtn"
            ref="always_focus"
            @click="show_dialog = false"
            >{{ $t("Cancel") }}</v-btn
          >
          <a type="button" download @click="generate">
            <v-btn
              id="yesBtn"
              style="margin-right: 15px !important"
              class="modal-btn-save yesBtn"
              :loading="loading"
              :disabled="loading"
              >{{ $t("Generate") }}</v-btn
            >
          </a>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
// import ACL from "../../acl";

import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "Exams",
  // components: { addEditExamComponent },
  mixins: [validationMixin],
  data() {
    return {
      show_export_error: false,
      export_error_msg: '',
      disabled: false,
      loading: false,
      year_name: "",
      academic_grade_id: "",
      grades: [],
      show_dialog: false,
      total_percentage: 0,
      valid: false,
      editMode: false,
      data: [],
      items: [],
      show_error_for_total: false,
      snack: "",
      snackTime: "300",
      snackText: "",
      snackColor: "success",
      exportLink: "",
    };
  },
  watch: {
    // academic_grade_id: {
    //   handler() {
    //     // this.exportLink = this.getApiUrl+'/performance/annual-percentage-segment-report/'+this.academic_grade_id
    //     this.generate();
    //   },
    // },
    // academic_grade_id: function(){
    //   console.log(this.academic_grade_id)
    //   this.exportLink = this.getApiUrl+'/performance/annual-percentage-segment-report/'+this.academic_grade_id
    // },
    // "editedItem.exam_date": {
    //   handler() {
    //     this.checkTime();
    //     // this.checkExamDate();
    //     // this.checkExamTime();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    getAllData() {
      axios
        .get(this.getApiUrl + "/performance/percentage-segments", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            //the token is a variable which holds the token
          },
        })
        .then((response) => {
          this.year_name = response.data.data.year_name;
          this.items = response.data.data.semesters;
          this.total_percentage = response.data.data.total_percentage;
        });
    },

    // onFocus() {
    //   this.validation_errors = {
    //     name: "",
    //     subject_id: "",
    //     qualifier_id: "",
    //     mark: "",
    //     exam_date: "",
    //     academic_year_id: "",
    //     randomiz: "",
    //     duration_hr: "",
    //   };
    // },
    calculate(semester) {
      var semesterTotal = 0;
      semester.quarters.forEach((el) => {
        semesterTotal += Number(el.quarter_percentage);
      });
      semester.semester_percentage = semesterTotal;
      this.calculateTotal();
    },
    calculateTotal() {
      var total = 0;
      this.items.forEach((el) => {
        total += Number(el.semester_percentage);
      });
      this.total_percentage = total;
      if (total != 100) {
        this.show_error_for_total = true;
      } else {
        this.show_error_for_total = false;
      }
    },
    save() {
      this.loading = true;
      if (this.show_error_for_total != true) {
        if (!this.valid) {
          this.$refs.form.validate();
          this.loading = false;
        } else {
          var data = {
            semesters: this.items,
          };
          axios
            .post(
              this.getApiUrl + "/performance/percentage-segments/update",
              {
                data,
              },
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token,
                  //the token is a variable which holds the token
                },
              }
            )
            .then((response) => {
              if (response.data.status.error == false) {
                this.getAllData();
                this.loading = false;
                this.editMode = false;
              }
            });
        }
      }
    },

    getGrades() {
      // elibrary/getGradesByFilter
      axios
        .get(this.getApiUrl + "/elibrary/getGradesByFilter", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            //the token is a variable which holds the token
          },
        })
        .then((response) => {
          this.grades = response.data.data;
          this.academic_grade_id = this.grades[0].academic_grade_id;
        });
    },
    generate() {
      this.loading = true;
      // if(! this.academic_grade_id){
      //   this.show_export_error = true;
      //   this.export_error_msg = "You have to select !";
      //   return ;
      // }
      axios
        .get(
          this.getApiUrl +
            "/performance/annual-percentage-segment-report/" +
            this.academic_grade_id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            this.show_export_error = false;
            this.export_error_msg = "";
            window.open(response.data.data, "_blank");
          } else {
            this.show_export_error = true;
            this.export_error_msg = response.data.status.message;
          }
          this.loading = false;
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
  mounted() {
    // this.subject_id = this.$router.currentRoute.params.subject_id;
    // this.academic_grade_id = this.$router.currentRoute.params.grade_id;
    // this.year_id = this.$router.currentRoute.params.year_id;
    // this.getQuarters();
    // setTimeout(() => {
    //   this.getQualifires();
    // }, 500);
    this.getAllData();
    this.getGrades();
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

// end search input
.title-page {
  margin-top: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.card-container {
  max-width: 80%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 50px;
}
.card-container .actions {
  position: absolute;
  top: -39px;
  right: 22px;
}
.card-container .actions i,
.card-container .actions span {
  cursor: pointer;
}
.card-container .actions span {
  margin-left: 5px;
}

.title-qualifire .divider {
  margin-top: 10px;
  margin-bottom: 10px;
}
.q-box-title {
  font-size: 29px;
  position: relative;
}

.q-box-title h2 {
  font-size: 25px;
  padding: 0;
  margin: 0;
}

.title-page {
  margin-top: 15px;
}
.semesters {
  margin-top: 2rem;
  text-align: left;
  overflow: hidden;
  font-size: 20px;
  font-weight: 600;
  color: #898787;
}
.semester-name {
  width: 22%;
  float: left;
}
.quarter-name {
  width: 75%;
  float: right;
}
.quarter {
  display: inline;
}
.percentage {
  margin-left: 0.5rem;
}
// .input-percentage,
// .input-percentage input,
// .input-percentage div {
//   display: inline !important;
//   width: 100px !important;
//   margin-left: 0.5rem !important;
// }

.equal {
  // margin-left: 2rem;
  // margin-right: 2rem;
  float: right;
}
.equal-s {
  margin-left: 2rem;
  margin-right: 2rem;
}
.btn-icon {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
.actions {
  position: absolute;
  top: -10px;
  right: 15%;
}
.actions i,
.actions span {
  cursor: pointer;
}
.actions span {
  margin-left: 5px;
}
.divider {
  background-color: #5a86ff !important;
  margin-bottom: 20px;
}
</style>
